import * as yup from "yup";

const createPlaceValidator = yup
  .object({
    name: yup.string().required("Name is required"),
    latitude: yup
      .string()
      .required("Latitude is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
    longitude: yup
      .string()
      .required("Longitude is required")
      .test("is-digit", "Input should be number", (value) =>
        /\d+$/.test(value)
      ),
  })
  .required();

export default createPlaceValidator;
